import { withGetItShippedProps } from 'viewModel/productPage/deliveryOptions/getItShipped/withGetItShippedProps';
import GetItShipped from 'components/ProductPage/DeliveryOptions/GetItShipped/GetItShipped';

export default withGetItShippedProps(GetItShipped);
